import React from 'react';
import { Container } from '@inlet/react-pixi'
import RainCloud from './RainCloud'

const Raining = () => {
    return (
        <Container>
            <RainCloud _xPos={180} _yPos={230} speed={0.1} max={250} min={100} _xSize={0.2} _ySize={0.2} />
            <RainCloud _xPos={600} _yPos={480} speed={0.1} max={600} min={400} _xSize={0.2} _ySize={0.2} />
            <RainCloud _xPos={700} _yPos={100} speed={0.1} max={700} min={550} _xSize={0.15} _ySize={0.15} />
            <RainCloud _xPos={1100} _yPos={120} speed={0.1} max={1200} min={1100} _xSize={0.25} _ySize={0.25} />
            <RainCloud _xPos={900} _yPos={600} speed={0.1} max={1050} min={900} _xSize={0.23} _ySize={0.23} />
            <RainCloud _xPos={1300} _yPos={450} speed={0.1} max={1450} min={1300} _xSize={0.29} _ySize={0.29} />
        </Container>
    );
};

export { Raining as default }